export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    PAY_TYPE_ALL: function PAY_TYPE_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/pay-type/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    PAY_TYPE_CREATE: function PAY_TYPE_CREATE(data) {
      return request({
        url: '/api/pay-type/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    PAY_TYPE_DETAIL: function PAY_TYPE_DETAIL(id) {
      return request({
        url: '/api/pay-type/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    PAY_TYPE_UPDATE: function PAY_TYPE_UPDATE(data) {
      return request({
        url: '/api/pay-type/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    PAY_TYPE_DELETE: function PAY_TYPE_DELETE(id) {
      return request({
        url: '/api/pay-type/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});